import { register } from 'tmr/tmr/ngModuleRegistry'

import './buttons'
import './dialogs'
import './menus'
import './modals'
import './navBar'
import './resourceActions'
import './resourceList'
import './resourceLists'
import './resourceView'

import * as alerts from './alerts/alerts'
import * as antennaControls from './antennaControls/antennaControls'
import * as antennaStatusHud from './antennaStatusHud/antennaStatusHud'
import * as app from './app/app'
import * as autocompleteChips from './autocompleteChips/autocompleteChips'
import * as breadcrumbs from './breadcrumbs/breadcrumbs'
import * as capabilitiesField from './capabilitiesField/capabilitiesField'
import * as chip from './chip/chip'
import * as datePickerRange from './datePickerRange/datePickerRange'
import * as descriptionCodeField from './descriptionCodeField/descriptionCodeField'
import * as detailItemList from './detailItemList/detailItemList'
import * as deviceControls from './deviceControls/deviceControls'
import * as itemCounter from './itemCounter/itemCounter'
import * as itemIdentifiers from './itemIdentifiers/itemIdentifiers'
import * as keyValueField from './keyValueField/keyValueField'
import * as logoSidebar from './logoSidebar/logoSidebar'
import * as pageTitle from './pageTitle/pageTitle'
import * as parcelFind from './parcelFind/parcelFind'
import * as parcelRowCounter from './parcelRowCounter/parcelRowCounter'
import * as placesTree from './placesTree/placesTree'
import * as productImage from './productImage/productImage'
import * as progressBar from './progressBar/progressBar'
import * as resourceDelete from './resourceDelete/resourceDelete'
import * as resourceFilter from './resourceFilter/resourceFilter'
import * as resourceForm from './resourceForm/resourceForm'
import * as resourceFormFooter from './resourceFormFooter/resourceFormFooter'
import * as resourceFormToolbar from './resourceFormToolbar/resourceFormToolbar'
import * as resourceSearchForm from './resourceSearchForm/resourceSearchForm'
import * as resourceSearchSummary from './resourceSearchSummary/resourceSearchSummary'
import * as sidebar from './sidebar/sidebar'
import * as switchWithInput from './switchWithInput/switchWithInput'
import * as validationItemCount from './validationItemCount/validationItemCount'
import * as workstationSelect from './workstationSelect/workstationSelect'

export default register(
  'tmr.core.components',
  alerts,
  antennaControls,
  antennaStatusHud,
  app,
  autocompleteChips,
  breadcrumbs,
  capabilitiesField,
  chip,
  datePickerRange,
  descriptionCodeField,
  detailItemList,
  deviceControls,
  itemCounter,
  itemIdentifiers,
  keyValueField,
  logoSidebar,
  pageTitle,
  parcelFind,
  parcelRowCounter,
  placesTree,
  productImage,
  progressBar,
  resourceDelete,
  resourceFilter,
  resourceForm,
  resourceFormFooter,
  resourceFormToolbar,
  resourceSearchForm,
  resourceSearchSummary,
  sidebar,
  switchWithInput,
  validationItemCount,
  workstationSelect
)
